/**
 * @see https://developer.mozilla.org/en-US/docs/Web/Manifest
 */
export const manifest = (storeName: string) => ({
  background_color: '#ffffff',
  description: `Shop ${storeName}'s in-store menu.`,
  display: 'standalone',
  name: `${storeName} Kiosk`,
  short_name: storeName,
});

export const rewriteManifest = (storeName: string) => {
  document?.querySelector('link[rel=manifest]')?.setAttribute(
    'href',
    URL.createObjectURL(
      new Blob([JSON.stringify(manifest(storeName))], {
        type: 'application/json',
      })
    )
  );
};
